import { dynamicElementsPillsNavigation } from '@epicuro-next/constants/dynamic-elements';
import { PANEL_STYLING_PROPERTIES } from '../../properties/panel-styling-properties';

export const pillsNavigation = {
  contentTypeId: dynamicElementsPillsNavigation,
  id: 'root',
  styles: {
    css: {
      provider: 'self',
      property: 'globalCss',
      filter: function (css: string | null | undefined): boolean {
        return css !== undefined && css !== null && css.trim() !== '';
      }.toString(),
    },
    dynamicClasses: { provider: 'self', property: 'rootDynamicClasses' },
    dynamicVariables: {
      provider: 'id:root',
      property: 'rootCssVariables',
    },
  },
  data: {
    ...PANEL_STYLING_PROPERTIES,
    configData: null,
    wrapItemsData: null,
  },
  inputs: {
    config: {
      provider: 'self',
      property: 'configData',
      transform: function (config: string) {
        return JSON.parse(config);
      }.toString(),
    },
    wrapItems: {
      provider: 'self',
      property: 'wrapItemsData',
    },
  },
};
